if (!customElements.get("m-hotspot-comparison")) {
  class HotspotComparison extends HTMLElement {
    constructor() {
      super();
      this.activeClass = "is-active";
      this.onHotspotHover = this.onHotspotHover.bind(this);
      this.onHotspotClick = this.onHotspotClick.bind(this);
    }

    connectedCallback() {
      this.hotspots = Array.from(this.querySelectorAll(".m-hotspot-comparison__hotspot"));
      this.comparisonItems = Array.from(this.querySelectorAll(".m-hotspot-comparison__comparison-item"));
      
      if (!this.hotspots.length) return;

      this.mediaQuery = window.matchMedia("(min-width: 768px)");
      this.initEvents();

      // Theme Editor integration
      if (typeof Shopify !== "undefined" && Shopify.designMode) {
        this.initThemeEditor();
      }

      // First hotspot active by default
      const initialActiveIndex = this.hotspots.findIndex(h => h.classList.contains(this.activeClass));
      this.setActive(initialActiveIndex >= 0 ? initialActiveIndex : 0);
    }

    disconnectedCallback() {
      this.removeEvents();
    }

    initEvents() {
      this.hotspots.forEach((hotspot, index) => {
        hotspot.dataset.index = index;
        
        // Desktop hover / focus events
        hotspot.addEventListener("mouseenter", this.onHotspotHover);
        hotspot.addEventListener("focus", this.onHotspotHover);

        // Mobile tap / click events
        hotspot.addEventListener("click", this.onHotspotClick);
      });
    }

    removeEvents() {
      this.hotspots.forEach((hotspot) => {
        hotspot.removeEventListener("mouseenter", this.onHotspotHover);
        hotspot.removeEventListener("focus", this.onHotspotHover);
        hotspot.removeEventListener("click", this.onHotspotClick);
      });
    }

    isDesktop() {
      return this.mediaQuery.matches;
    }

    onHotspotHover(event) {
      if (this.isDesktop()) {
        const index = parseInt(event.currentTarget.dataset.index, 10);
        if (!isNaN(index)) {
          this.setActive(index);
        }
      }
    }

    onHotspotClick(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10);
      if (!isNaN(index)) {
        this.setActive(index);
      }
    }

    setActive(index) {
      if (index < 0 || index >= this.hotspots.length) return;

      // Update active hotspot pin
      this.hotspots.forEach((h) => h.classList.remove(this.activeClass));
      if (this.hotspots[index]) {
        this.hotspots[index].classList.add(this.activeClass);
      }

      // Update active comparison image item on right
      this.comparisonItems.forEach((item) => item.classList.remove(this.activeClass));
      if (this.comparisonItems[index]) {
        this.comparisonItems[index].classList.add(this.activeClass);
      }
    }

    initThemeEditor() {
      const sectionId = this.getAttribute("data-section-id");
      if (!sectionId) return;

      document.addEventListener("shopify:block:select", (event) => {
        if (event.detail.sectionId === sectionId) {
          const blockId = event.detail.blockId;
          const targetIndex = this.hotspots.findIndex(
            (h) => h.getAttribute("data-block-id") === blockId
          );
          if (targetIndex >= 0) {
            this.setActive(targetIndex);
          }
        }
      });
    }
  }

  customElements.define("m-hotspot-comparison", HotspotComparison);
}
